/**
 * Guest-realm source for the FTP extension. FTP is host-rendered
 * (FtpSidebar.js + FtpView.js) and calls the Rust ftp_* commands directly via
 * invoke — credentials come from the vault and never enter the guest sandbox.
 * This entry script is a no-op kept only to satisfy the extension
 * registration contract.
 */
export const ftpEntrySource = `
(function () {
  var sdk = window.apibooSDK;
  sdk.onActivate(function () {});
})();
`;
